/**
 * Menu Builder API — configurable left sidebar.
 *
 * Backend: apps/branding/views/menu_views.py (mounted at /api/v1/branding/menu/).
 * Scope values: 'me' | 'company' | 'user' (user requires user_id).
 */
import apiClient from '@/api/client'

export const menuBuilderApi = {
  // Effective layout for the current user (personal -> company -> default).
  // skipErrorLog: a missing/новый эндпоинт must never spam the error journal.
  effective() {
    return apiClient.get('/branding/menu/', { skipErrorLog: true })
  },

  // Raw saved layout for a scope (for the builder editor).
  getLayout(scope = 'me', userId = null) {
    return apiClient.get('/branding/menu/layout/', {
      params: { scope, ...(userId ? { user_id: userId } : {}) },
    })
  },

  saveLayout(scope, layout, userId = null) {
    return apiClient.put('/branding/menu/layout/', {
      scope, layout, ...(userId ? { user_id: userId } : {}),
    })
  },

  resetLayout(scope, userId = null) {
    return apiClient.delete('/branding/menu/layout/', {
      params: { scope, ...(userId ? { user_id: userId } : {}) },
    })
  },

  listTemplates() {
    return apiClient.get('/branding/menu/templates/')
  },

  createTemplate(name, layout, isShared = false) {
    return apiClient.post('/branding/menu/templates/', {
      name, layout, is_shared: isShared,
    })
  },

  updateTemplate(id, { name = undefined, layout = undefined } = {}) {
    const body = {}
    if (name !== undefined) body.name = name
    if (layout !== undefined) body.layout = layout
    return apiClient.put(`/branding/menu/templates/${id}/`, body)
  },

  deleteTemplate(id) {
    return apiClient.delete(`/branding/menu/templates/${id}/`)
  },

  applyTemplate(id, scope, userId = null) {
    return apiClient.post(`/branding/menu/templates/${id}/apply/`, {
      scope, ...(userId ? { user_id: userId } : {}),
    })
  },

  // Roles + permission codes for the Access & Security matrix (admin only).
  roles() {
    return apiClient.get('/branding/menu/roles/', { skipErrorLog: true })
  },
}

export default menuBuilderApi
